var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("antesZeramento"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.selectAntesZeramento("antesZeramento")
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-filter" }),
          _vm._v(" Antes do zeramento\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("abertura"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("abertura")
            },
          },
        },
        [_c("i", { staticClass: "fa fa-filter" }), _vm._v(" Abertura\n  ")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("fechamentoGerencial"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("fechamentoGerencial")
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-filter" }),
          _vm._v(" Fechamentos gerenciais\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn",
          class: _vm.getClass("considerarLalur"),
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.filterSelected("considerarLalur")
            },
          },
        },
        [
          _c("i", { staticClass: "fa fa-filter" }),
          _vm._v(" Considerar apuração do LALUR\n  "),
        ]
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        { staticClass: "date-picker", attrs: { name: "slide-fade" } },
        [
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isIgnorarPosteriorEnabled(),
                  expression: "isIgnorarPosteriorEnabled()",
                },
              ],
              key: "ignorarPosteriorKey",
            },
            [
              _c("br"),
              _vm._v(" "),
              _c(
                "a",
                {
                  ref: "posteriorInput",
                  staticClass: "btn",
                  class:
                    ((_obj = {}),
                    (_obj[_vm.colorSelected] = true),
                    (_obj[_vm.colorDeselected] = false),
                    (_obj["btn-circle"] = _vm.isButtonCircle()),
                    _obj),
                  attrs: { name: "ignoreDate" },
                },
                [
                  _c("i", { staticClass: "fa fa-calendar" }),
                  _vm._v(
                    " Ignorar posteriores a " +
                      _vm._s(_vm.posteriorText) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }